import { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react';
import { auth, logout } from '../../lib/firebase.ts';
import { checkAuth } from '../../lib/api-client.ts';
import { Spin } from 'antd';

type AuthStatus = 'loading' | 'unauthenticated' | 'authenticated';

type AuthContextType = {
  status: AuthStatus;
  error?: string;
};

const AuthContext = createContext<AuthContextType>({
  status: 'loading',
});

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const [status, setStatus] = useState<AuthStatus>('loading');
  const [error, setError] = useState<string>();
  const [isLoading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    auth.onAuthStateChanged(async (user) => {
      const sitter = await checkAuth();

      if (!user) {
        setStatus('unauthenticated');
      } else {
        if (sitter === 'invalid sitter') {
          console.log('db登録待ち');
        } else if (!sitter) {
          setError('シッター情報が見つかりませんでした。');
          console.log('シッター情報が見つかりませんでした。');

          await logout();
        } else {
          setStatus('authenticated');
        }
      }

      setLoading(false);
    });
  }, []);

  return (
    <AuthContext.Provider value={{ status, error }}>
      {children}
      <Spin delay={500} spinning={isLoading} fullscreen />
    </AuthContext.Provider>
  );
};
